import { render, staticRenderFns } from "./ResumeEditor.vue?vue&type=template&id=232a8565"
import script from "./ResumeEditor.vue?vue&type=script&lang=js"
export * from "./ResumeEditor.vue?vue&type=script&lang=js"
import style0 from "./ResumeEditor.vue?vue&type=style&index=0&id=232a8565&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports